export { default } from './GradientBG';
